// extracted by mini-css-extract-plugin
export default {"tableBody":"LedgerAccounts_tableBody__7jOFi"};